import {
  LOGOUT,
  FETCH_PRODUCT_SUBSCRIPTIONS,
  REFRESH_PROFILE,
  SELECT_UNSUBSCRIPTION,
  RESET_UNSUBSCRIPTION,
  UNSUBSCRIBE,
  UPDATE_POLICIES,
} from '../constants/actionTypes';

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function fetchProductSubscriptions() {
  return {
    type: FETCH_PRODUCT_SUBSCRIPTIONS,
  };
}

export function refreshProfile() {
  return {
    type: REFRESH_PROFILE,
  };
}

/**
 *
 * @typedef {object} VIPUnsubscription
 * @property {import('../../constants/payment').SUBSCRIPTION_TYPE_VIP} type
 *
 * @typedef {object} PackageUnsubscription
 * @property {import('../../constants/payment').SUBSCRIPTION_TYPE_PACKAGE} type
 * @property {number} id
 *
 * @typedef {PackageUnsubscription|VIPUnsubscription} Unsubscription
 *
 * @param {Unsubscription} unsubscription
 */
export function selectUnsubscription(unsubscription) {
  return {
    type: SELECT_UNSUBSCRIPTION,
    payload: unsubscription,
  };
}

export function resetUnsubscription() {
  return {
    type: RESET_UNSUBSCRIPTION,
  };
}

export function unsubscribe() {
  return { type: UNSUBSCRIBE };
}

export function updatePolicies(payload) {
  return {
    type: UPDATE_POLICIES,
    payload,
  };
}
